import React from "react";
import { useContent } from "../lib/content";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { MessageCircle, Instagram } from "lucide-react";

export default function Contact() {
  const { c } = useContent();
  const faqs = c.faqs || [];
  return (
    <div className="max-w-[1200px] mx-auto px-4 lg:px-8 py-16">
      <div className="grid lg:grid-cols-2 gap-16">
        <div>
          <div className="label-mono text-neon mb-2">{c.faq_label}</div>
          <h1 className="font-display text-4xl lg:text-6xl mb-8">{c.faq_title}</h1>
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((f, i) => (
              <AccordionItem key={`${i}-${f.q}`} value={`item-${i}`} className="border-neutral-800" data-testid={`faq-${i}`}>
                <AccordionTrigger className="font-display text-left hover:text-neon hover:no-underline">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-neutral-400 font-body">{f.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
        <div>
          <div className="label-mono text-alert mb-2">{c.contact_label}</div>
          <h2 className="font-display text-4xl lg:text-6xl mb-8">{c.contact_title}</h2>
          <p className="text-neutral-400 mb-8" data-testid="contact-text">{c.contact_text}</p>
          <div className="space-y-4">
            <a href={`https://wa.me/${c.whatsapp_number || ""}`} target="_blank" rel="noopener noreferrer"
              className="card-dark p-5 flex items-center gap-4 hover:border-neon" data-testid="contact-whatsapp">
              <div className="w-12 h-12 flex items-center justify-center border border-neon"><MessageCircle className="w-5 h-5 text-neon"/></div>
              <div>
                <div className="font-display text-lg">WHATSAPP</div>
                <div className="font-mono text-xs text-neutral-500 tracking-widest">{c.whatsapp_display}</div>
              </div>
            </a>
            <a href={`https://instagram.com/${c.instagram_handle || ""}`} target="_blank" rel="noopener noreferrer"
              className="card-dark p-5 flex items-center gap-4 hover:border-neon" data-testid="contact-instagram">
              <div className="w-12 h-12 flex items-center justify-center border border-neon"><Instagram className="w-5 h-5 text-neon"/></div>
              <div>
                <div className="font-display text-lg">INSTAGRAM</div>
                <div className="font-mono text-xs text-neutral-500 tracking-widest">@{c.instagram_handle}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
